import { render } from "./MediaPerformanceWidget.vue?vue&type=template&id=6c713b06&scoped=true"
import script from "./MediaPerformanceWidget.vue?vue&type=script&lang=js"
export * from "./MediaPerformanceWidget.vue?vue&type=script&lang=js"

import "./MediaPerformanceWidget.vue?vue&type=style&index=0&id=6c713b06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c713b06"]])

export default __exports__